import { Zap, Cable, Building2 } from "lucide-react";
import { IMAGES } from "../../data/site";
import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

const ICONS = { Zap, Cable, Building2 };

export const About = () => {
    const { ui, site } = useContent();
    return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 section-grid">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <SectionHeader
                chapter={ui.about.chapter}
                overline={ui.about.overline}
                title={ui.about.title}
            />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <div className="lg:col-span-5">
                    <Reveal>
                        <p className="text-white text-lg lg:text-xl leading-relaxed font-medium">
                            {ui.about.lead}
                        </p>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <div className="mt-8 border-l-2 border-[#f6c422] pl-6">
                            <p className="overline-text mb-3">{ui.about.objectiveLabel}</p>
                            <p className="text-[#a2a59d] text-base leading-relaxed">
                                {ui.about.objective}
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <div className="mt-10 relative overflow-hidden border border-[#4a4c42]">
                            <img
                                src={IMAGES.about}
                                alt={ui.about.imgAlt}
                                className="w-full h-56 object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-[#292a24]/30" />
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-7 flex flex-col">
                    {site.sectors.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <Reveal key={s.num} delay={0.08 * i}>
                                <div
                                    data-testid={`sector-card-${s.num}`}
                                    className="group flex items-start gap-6 sm:gap-10 py-8 border-t border-[#4a4c42] last:border-b hover:bg-[#32332c]/60 transition-colors duration-500 px-2 sm:px-6"
                                >
                                    <span className="font-display text-sm text-[#a2a59d]/50 tracking-[0.2em] pt-2">
                                        {s.num}
                                    </span>
                                    <div className="shrink-0 w-12 h-12 border border-[#4a4c42] flex items-center justify-center group-hover:border-[#f6c422] transition-colors duration-500">
                                        <Icon className="w-5 h-5 text-[#f6c422]" strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <h3 className="font-display text-xl sm:text-2xl font-bold tracking-[0.08em] text-white uppercase">
                                            {s.title}
                                        </h3>
                                        <p className="text-[#a2a59d] text-sm sm:text-base mt-2 leading-relaxed max-w-lg">
                                            {s.desc}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </div>
    </section>
    );
};
